// extracted by mini-css-extract-plugin
module.exports = {"Color":"ColorSelector_Color__214JJ","Active":"ColorSelector_Active__10rJT"};